<span style="margin-right: .5em">
    <img
        [ngStyle]="{'width': width || defaultWidth, 'height': height || defaultHeight}"
        class="avatar"
        [src]="image || defaultImage">
</span>
